/**
 * Provides resources for Team Calendar functionality.
 * The functionality comes from a plugin teamcal.
 */

import initMacroButtonPanel from './macro-button-panel';
import initHelptip from './helptip-component';

export const teamCalendarWRM = () => [
	// transitional and implicit dependecies
	'wrc!com.atlassian.confluence.extra.team-calendars:amd',
	'wrc!com.atlassian.confluence.extra.team-calendars:user-timezone-setup',

	// editor context
	'wrc!com.atlassian.confluence.extra.team-calendars:calendar-init-editor',
	// 'wrc!com.atlassian.confluence.extra.team-calendars:calendar-print-resources',

	// ported to CFE
	// 'wrc!com.atlassian.confluence.extra.team-calendars:macro-button-panel-resources',
	//'wrc!com.atlassian.confluence.extra.team-calendars:autoconvert-resources',
	//'wrc!com.atlassian.confluence.extra.team-calendars:helptip-resources-for-frontend',

	// macro-browser (not loaded by macro browser for some reason)
	'wrc!com.atlassian.confluence.extra.team-calendars:macro-browser-web-resources',
];

export const teamCalendar = () => {
	// initAutoconvert();   // TODO: this does not seem to do anything in the editor
	initMacroButtonPanel();
	initHelptip();
};
